import {
  getList,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { Role, RoleDTO } from "./role";
/* eslint-disable import/export */
export abstract class GetBOUserRolesRPC implements
  LeoRPC<GetBOUserRolesRPC.Request, GetBOUserRolesRPC.Response, GetBOUserRolesRPC.Errors.Errors>
{
  abstract execute(
    request: GetBOUserRolesRPC.Request
  ): Promise<LeoRPCResult<GetBOUserRolesRPC.Response, GetBOUserRolesRPC.Errors.Errors>>;
}

export namespace GetBOUserRolesRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {}

  export class Request implements LeoRPCRequest {
    readonly isGetBOUserRolesRPCRequest: boolean = true;
    toDTO(): RequestDTO {
      return {}
    }
  }

  Request.prototype.toString = function toString(): string {
    return `GetBOUserRolesRPC.Request`;
  };

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    roles: RoleDTO[];
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetBOUserRolesResponse: boolean = true;
  
    readonly roles: Role[];
  
  
    constructor(
    roles: Role[]
    ) {
      this.roles = roles;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const roles = getList<RoleDTO, Role>(
        dto,
        "roles",
        Role.fromDTO,
        InvalidResponseRolesError
      );
      return new Response(
        roles
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          roles: this.roles.map((e: Role) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetBOUserRoles(roles='${this.roles}')`;
  };
  

  export enum RPCError {
    UnableToFetchRoles = "UNABLE_TO_FETCH_ROLES"
  }

  export namespace Errors {
    
    export interface UnableToFetchRolesDTO {
      code: string;
    }
    
    export class UnableToFetchRoles extends LeoRPCError<RPCError> {
      readonly isUnableToFetchRoles: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.UnableToFetchRoles;
        super(code);
      }
    
    
      toDTO(): UnableToFetchRolesDTO {
        const dto: UnableToFetchRolesDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    UnableToFetchRoles.prototype.toString = function toString(): string {
      return `GetBOUserRolesRPC.UNABLE_TO_FETCH_ROLES()`;
    };
    

    export type Errors = UnableToFetchRoles;
    export type ErrorsDTO = UnableToFetchRolesDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.UnableToFetchRoles:
          return new UnableToFetchRoles();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}


export class InvalidResponseRolesError extends GetBOUserRolesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseRolesError";
  }
}

export class InvalidResponseUnableToFetchRolesError extends GetBOUserRolesRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseUnableToFetchRolesError";
  }
}

